import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ClaimIcon: React.FC<CardGradientProps> = ({
  className,
  width = "17",
  height = "17",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70801 8.65837L6.99551 7.94587C6.85037 7.80073 6.66565 7.72817 6.44134 7.72817C6.21704 7.72817 6.03231 7.80073 5.88717 7.94587C5.74204 8.09101 5.66947 8.27573 5.66947 8.50004C5.66947 8.72435 5.74204 8.90907 5.88717 9.05421L7.94551 11.1125C8.10384 11.2709 8.28856 11.35 8.49967 11.35C8.71078 11.35 8.89551 11.2709 9.05384 11.1125L11.1122 9.05421C11.2573 8.90907 11.3299 8.72435 11.3299 8.50004C11.3299 8.27573 11.2573 8.09101 11.1122 7.94587C10.967 7.80073 10.7823 7.72817 10.558 7.72817C10.3337 7.72817 10.149 7.80073 10.0038 7.94587L9.29134 8.65837V6.12504C9.29134 5.90073 9.21547 5.71271 9.06374 5.56098C8.912 5.40924 8.72398 5.33337 8.49967 5.33337C8.27537 5.33337 8.08735 5.40924 7.93561 5.56098C7.78388 5.71271 7.70801 5.90073 7.70801 6.12504V8.65837ZM8.49967 16.4167C7.40454 16.4167 6.37537 16.2089 5.41217 15.7933C4.44898 15.3776 3.61113 14.8136 2.89863 14.1011C2.18613 13.3886 1.62207 12.5507 1.20645 11.5875C0.79082 10.6243 0.583008 9.59518 0.583008 8.50004C0.583008 7.4049 0.79082 6.37573 1.20645 5.41254C1.62207 4.44935 2.18613 3.6115 2.89863 2.899C3.61113 2.1865 4.44898 1.62244 5.41217 1.20681C6.37537 0.791186 7.40454 0.583374 8.49967 0.583374C9.59481 0.583374 10.624 0.791186 11.5872 1.20681C12.5504 1.62244 13.3882 2.1865 14.1007 2.899C14.8132 3.6115 15.3773 4.44935 15.7929 5.41254C16.2085 6.37573 16.4163 7.4049 16.4163 8.50004C16.4163 9.59518 16.2085 10.6243 15.7929 11.5875C15.3773 12.5507 14.8132 13.3886 14.1007 14.1011C13.3882 14.8136 12.5504 15.3776 11.5872 15.7933C10.624 16.2089 9.59481 16.4167 8.49967 16.4167Z"
        fill="#FFA686"
      />
    </svg>
  );
};

export default ClaimIcon;
